import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import JsonapiClient from '@holidayextras/jsonapi-client';
import StatusBar from '../../containers/status-bar';
import { setStatusBar } from '../../containers/status-bar/actions';
import Invitation from '../../containers/invitation';

import { authService } from '../../utils/auth-service';


const pStyle = {
  textAlign: 'center',
};

const pageStyle = {
  marginTop: 50,
};

class CampaignInviteMore extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    routeParams: PropTypes.object.isRequired,
  };

  constructor() {
    super();

    this.state = {
      campaign: null,
    };

    this.client = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  getProfile = () => {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem('profile');
    return profile ? JSON.parse(localStorage.profile) : {};
  }

  componentDidMount = () => {
    const campaignId = this.props.routeParams.id;
    this.client.get('campaigns', campaignId, { include: ['members', 'pendingInvitations', 'discussions'] })
      .then(newCampaign => {
        this.setState({
          campaign: newCampaign.toJSONTree(),
        });
      });
  }

  goToCampaign = () => {
    const campaignId = this.props.routeParams.id;
    this.context.router.push(`/campaign/${campaignId}`);
  }

  render() {
    const { campaign } = this.state;
    const profile = this.getProfile();
    const organisationId = profile.app_metadata.dyzio.o_id;

    const organisation = _.get(this.props, 'user.user.organisation', {});

    return (
      <div className="page">

        <div className="page-content">
          <div className="grid">

            <div style={pageStyle}>
              <StatusBar />
              { campaign &&
                <Invitation
                  campaign={campaign}
                  organisationId={organisationId}
                  organisation={organisation}
                />
              }
            </div>

          </div>
        </div>
      </div>
    );
  }
}

CampaignInviteMore.propTypes = {
  routeParams: React.PropTypes.object,
};

const mapStateToProps = state => ({
  currentUser: state.userData.get('currentUser'),
  user: state.user,
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetStatusBar: (message, colour) =>
      dispatch(setStatusBar(message, colour)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignInviteMore);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-invite-more/index.js
 **/